import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setPage, setSelectedProjectChat } from "../../lib/redux/actions";


export const ProjectChatHistory = ({sessions,projectId,projectName,projectType,setProjectChats}) => {
    const router = useNavigate();
    const dispatch = useDispatch()
    return (
        <div className="h-[250px] mt-[20px] w-full md:max-w-[768px] 2xl:max-w-5xl overflow-y-auto flex flex-col gap-2 ">
           
            {sessions?.map((chat) => (
                <div key={chat.id} onClick={()=>{
                    setProjectChats([]);
                    dispatch(setPage(1));
                    dispatch(setSelectedProjectChat(chat));
                    router(`/project/${projectName}/${projectType}/${projectId}/${chat._id}`)
                }} className="hover:bg-white p-1 rounded-[10px] cursor-pointer w-full flex flex-row justify-between items-center">
                    <div className="flex flex-col gap-1">
                    <h2 className="text-[#000000BF] font-bold text-sm pt-0.3">{chat.title}</h2>
                    <p className="font-normal text-[#000000BF] text-sm">{chat.subTitle}</p>
                    </div>
                    <div>
                   <p className="font-normal text-[#000000BF] text-sm">
                    {new Date(chat.createdAt).toLocaleDateString("en-US", {
                        month: "short",
                        day: "2-digit",
                    })}
                    </p>

                    </div>
                </div>
            ))}
        </div>
    );
};